import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = ["00", "15", "30", "45"];

export function TimeSelect({ value, onChange, testid }) {
  const parts = (value || "09:00").split(":");
  const h = parts[0] || "09";
  const m = MINUTES.includes(parts[1]) ? parts[1] : "00";
  const set = (nh, nm) => onChange(`${nh}:${nm}`);
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <Select value={h} onValueChange={(v) => set(v, m)}>
        <SelectTrigger className="mt-1.5 bg-slate-50" data-testid={`${testid}-hour`}><SelectValue /></SelectTrigger>
        <SelectContent className="max-h-60">{HOURS.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
      </Select>
      <span className="mt-1.5 font-bold text-[#64748B]">:</span>
      <Select value={m} onValueChange={(v) => set(h, v)}>
        <SelectTrigger className="mt-1.5 bg-slate-50" data-testid={`${testid}-min`}><SelectValue /></SelectTrigger>
        <SelectContent>{MINUTES.map((x) => <SelectItem key={x} value={x}>{x}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}
